import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tenverly_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("tenverly_token"))
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    localStorage.setItem("tenverly_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password, turnstileToken) => {
    const res = await api.post("/auth/login", { email, password, turnstile_token: turnstileToken });
    return persist(res.data);
  };

  const register = async (payload) => {
    const res = await api.post("/auth/register", payload);
    persist(res.data);
    return res.data;
  };

  const refreshUser = async () => {
    const res = await api.get("/auth/me");
    setUser(res.data);
    return res.data;
  };

  const resendVerification = async () => {
    const res = await api.post("/auth/resend-verification");
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("tenverly_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, resendVerification }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
